/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button, Group, Space } from '@mantine/core';
import { useModals } from '@mantine/modals';
import { IconCheck, IconPlus, IconScale, IconShare, IconX } from '@tabler/icons-react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { forwardRef, useImperativeHandle, useState } from 'react';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import { useProposalGeneralContext } from '../../../../../../contexts/core/proposals/ProposalGeneral.context';
import { ProposalServiceProvider } from '../../../../../../contexts/core/proposals/ProposalService.context';
import { EntityTypeType, UnitOfMeasureType } from '../../../../../../models/core/cache.type';
import { Action, ItemToleranceType } from '../../../../../../models/core/core.type';
import {
  ProposalServiceQuotationType,
  ProposalServiceType,
  ProposalType,
} from '../../../../../../models/core/proposals.type';
import { montarRecorrenciaString } from '../../../../../../utils/business.utils';
import { Feature } from '../../../../../../utils/constants.utils';
import { newGuid } from '../../../../../../utils/helper.utils';
import ServiceQuotationEditor from './ServiceFormView/components/ServiceQuotationEditor';
import ServiceFormAddEdit from './ServiceFormView/ServiceFormAddEdit';
import ServiceFormViewActions from './ServiceFormView/ServiceFormViewActions';

type ProposalServiceFormViewProps = {
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
    entityTypeData: EntityTypeType[];
  };
  proposal: ProposalType | null;
  zIndex: number;
};

const ServiceFormView = forwardRef((props: ProposalServiceFormViewProps, ref) => {
  const { proposalGeneralData, setProposalGeneralData } = useProposalGeneralContext();
  const modals = useModals();

  const [data, setData] = useState<ProposalServiceType[]>(
    props.proposal?.servicos.map((x) => ({
      ...x,
      action: Action.Nothing,
      id: x.idPropostaServico?.toString() || '',
    })) || []
  );

  const openServiceEditor = (
    item: ProposalServiceType | null,
    options?: {
      serviceTab?: string;
      quotationItem?: ProposalServiceQuotationType | null;
      quotationTab?: string;
      autoOpenQuotationModal?: boolean;
    }
  ) => {
    modals.openModal({
      title: `Serviço - ${item ? 'Editar' : 'Adicionar'}`,
      size: '80%',
      closeOnClickOutside: false,
      children: (
        <ProposalServiceProvider>
          <ServiceFormAddEdit
            referenceData={props.referenceData}
            proposalGeneralData={proposalGeneralData}
            origItem={
              item
                ? props.proposal?.servicos.find((x) => x.idPropostaServico === item.idPropostaServico) || null
                : null
            }
            item={item}
            idProposta={props.proposal?.idProposta}
            callback={confirmActionResult}
            zIndex={props.zIndex + 1}
            defaultActiveKey={options?.serviceTab || 'Geral'}
            initialQuotationItem={options?.quotationItem || null}
            initialQuotationTab={options?.quotationTab || 'Cotacao'}
            autoOpenQuotationModal={options?.autoOpenQuotationModal || false}
          />
        </ProposalServiceProvider>
      ),
    });
  };

  // const buildPrimaryQuotation = (row: ProposalServiceType) => {
  //   const primaryQuotation = row.cotacoes.find((x) => x.primario && x.action !== Action.Delete);
  //   if (!primaryQuotation) {
  //     return (
  //       <Text size="sm" c="dimmed">
  //         Não definida
  //       </Text>
  //     );
  //   }

  //   return (
  //     <Stack gap={2}>
  //       <Text size="xs" fw={600}>
  //         {primaryQuotation.fornecedorNomeFantasia ||
  //           primaryQuotation.fornecedorRazaoSocial ||
  //           primaryQuotation.fornecedorNome ||
  //           '-'}
  //       </Text>
  //       <Text size="xs">
  //         {primaryQuotation.preco ? formatCurrency(primaryQuotation.preco) : '-'}
  //         {' | '}
  //         {primaryQuotation.quantidade} Unidade(s) / {primaryQuotation.frequenciaUnidadeMedida2}
  //       </Text>
  //     </Stack>
  //   );
  // };

  const columns: ColumnsType<any> = [
    {
      title: 'Serviço',
      key: 'servico',
      dataIndex: 'servico',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => a.servico.localeCompare(b.servico),
    },
    {
      title: 'Item',
      key: 'item',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => {
        const aItem = a.residuoAcondicionamento || a.residuoEquipamento || '-';
        const bItem = b.residuoAcondicionamento || b.residuoEquipamento || '-';
        return aItem.localeCompare(bItem);
      },
      render: (row: ProposalServiceType) => {
        if (row.idResiduoAcondicionamento) {
          return (
            <ProfileCardLink
              id={(row.idResiduoAcondicionamento || '').toString()}
              name={row.residuoAcondicionamento || '-'}
              nameSize="sm"
              description={row.residuoAcondicionamentoDescricao}
              descriptionSize="xs"
              linkPrefix="packaging"
              showLink
            />
          );
        }
        if (row.idResiduoEquipamento) {
          return (
            <ProfileCardLink
              id={(row.idResiduoEquipamento || '').toString()}
              name={row.residuoEquipamento || '-'}
              nameSize="sm"
              description={row.residuoEquipamentoDescricao}
              descriptionSize="xs"
              linkPrefix="equipment"
              showLink
            />
          );
        }
        return (
          <ProfileCardLink
            id={newGuid.toString()}
            name="Fornecedor"
            nameSize="sm"
            description={null}
            descriptionSize="xs"
            showLink={false}
          />
        );
      },
    },
    {
      title: 'Quantidade',
      key: 'quantidade',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => a.quantidade - b.quantidade,
      render: (row: ProposalServiceType) => <div>{row.quantidade.toString()}</div>,
    },
    {
      title: 'Frequência',
      key: 'frequencia',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => {
        const aIsService = !(a.idResiduoAcondicionamento || a.idResiduoEquipamento);
        const bIsService = !(b.idResiduoAcondicionamento || b.idResiduoEquipamento);
        const aItem = `${aIsService ? `${a.frequencia} ` : ''}${a.frequenciaUnidadeMedida1} / ${
          a.frequenciaUnidadeMedida2
        }`;
        const bItem = `${bIsService ? `${b.frequencia} ` : ''}${b.frequenciaUnidadeMedida1} / ${
          b.frequenciaUnidadeMedida2
        }`;
        return aItem.localeCompare(bItem);
      },
      render: (row: ProposalServiceType) => {
        const isService = !(row.idResiduoAcondicionamento || row.idResiduoEquipamento);
        return (
          <div>{`${isService ? `${row.frequencia} ` : ''}${row.frequenciaUnidadeMedida1} / ${
            row.frequenciaUnidadeMedida2
          }`}</div>
        );
      },
    },
    {
      title: 'Recorrência',
      key: 'recorrencia',
      render: (row: ProposalServiceType) => {
        const recorrencia = montarRecorrenciaString(row.recorrencia);
        if (!recorrencia) {
          return '-';
        }
        return (
          <div>
            <div>{recorrencia.str1}</div>
            {recorrencia.str2 ? <div>{recorrencia.str2}</div> : <></>}
          </div>
        );
      },
    },
    // {
    //   title: 'Precificação',
    //   key: 'precoCliente',
    //   render: (row: ProposalServiceType) => {
    //     if (row.precificacao?.preco === null || row.precificacao?.preco === undefined) {
    //       return '-';
    //     }
    //     return (
    //       <Stack gap={2}>
    //         <Text size="sm">
    //           {row.precificacao.preco ? formatCurrency(row.precificacao.preco) : '-'}
    //           {' | '}
    //           {row.precificacao.quantidade} {row.precificacao.quantidadeUnidadeMedida} /{' '}
    //           {row.precificacao.frequenciaUnidadeMedida}
    //         </Text>
    //       </Stack>
    //     );
    //   },
    // },
    // {
    //   title: 'Cotação Primária',
    //   key: 'cotacaoPrimaria',
    //   sorter: (a: ProposalServiceType, b: ProposalServiceType) =>
    //     (a.cotacoes.find((x) => x.primario)?.preco || 0) - (b.cotacoes.find((x) => x.primario)?.preco || 0),
    //   render: (row: ProposalServiceType) => buildPrimaryQuotation(row),
    // },
    {
      title: 'Cotações',
      key: 'cotacoes',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) =>
        a.cotacoes.filter((x) => x.action !== Action.Delete).length -
        b.cotacoes.filter((x) => x.action !== Action.Delete).length,
      render: (row: ProposalServiceType) => {
        const visibleQuotations = row.cotacoes.filter((x) => x.action !== Action.Delete);
        const toleranceCount = visibleQuotations.reduce(
          (acc, item) => acc + (item.tolerancias?.length || 0),
          0
        );
        return (
          <Group gap="xs">
            <div>{visibleQuotations.length || '-'}</div>
            <div>
              {visibleQuotations.some((x) => x.primario) ? (
                <IconCheck color="green" />
              ) : (
                <IconX color="red" />
              )}
            </div>
            <Group gap={4}>
              <IconScale size={16} />
              <div>{toleranceCount}</div>
            </Group>
            {row.compartilhado && (
              <div>
                <IconShare size={16} />
              </div>
            )}
          </Group>
        );
      },
    },
    {
      title: 'Ações',
      width: '100px',
      render: (row: ProposalServiceType) => (
        <ServiceFormViewActions item={row} confirmActionResult={confirmActionResult} />
      ),
    },
  ];

  const confirmActionResult = (item: ProposalServiceType | null, action: string, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }

    let dataItemIndex;
    let dataItem;

    switch (action) {
      case 'excluir':
        dataItemIndex = data.findIndex((x) => x.id === item?.id);
        if (dataItemIndex > -1) {
          dataItem = data[dataItemIndex];
          if (dataItem.idPropostaServico) {
            data[dataItemIndex] = { ...dataItem, action: Action.Delete };
          } else {
            data.splice(dataItemIndex, 1);
          }
          setProposalGeneralData({ ...proposalGeneralData, servicos: data });
          setData(JSON.parse(JSON.stringify(data)));
        }
        break;
      case 'editar':
        openServiceEditor(item, { serviceTab: 'Geral' });
        break;
      case 'cotacoes':
        openServiceEditor(item, { serviceTab: 'Cotacoes' });
        break;
      case 'adicionar':
        openServiceEditor(null, { serviceTab: 'Geral' });
        break;
      case 'callback':
        modals.closeAll();
        dataItemIndex = data.findIndex((x) => x.id === item?.id);
        if (dataItemIndex > -1) {
          dataItem = data[dataItemIndex];
          data[dataItemIndex] = { ...dataItem, ...item };
        } else {
          data.push(item!);
        }
        setProposalGeneralData({ ...proposalGeneralData, servicos: data });
        setData(data);
        break;
      default:
        break;
    }
  };

  useImperativeHandle(ref, () => ({
    validate(): ProposalServiceType[] {
      data.forEach((x: ProposalServiceType) => {
        delete (x as any).clienteData;
        delete (x as any).enderecoData;
        (x as any).turno = x.turno ? Number(x.turno) : null;

        x.recorrencia.action = x.recorrencia?.action || Action.Nothing;
        x.cotacoes.forEach((y: ProposalServiceQuotationType) => {
          y.action = y.action || Action.Nothing;
          y.tolerancias.forEach((z: ItemToleranceType) => {
            z.action = z.action || Action.Nothing;
          });
        });
      });
      return data;
    },
    clear() {
      setData([]);
    },
  }));

  return (
    <div>
      <Group justify="space-between">
        <PageSection
          size="lg"
          color={Feature.Home.Proposal.color}
          label="Serviços"
          text="Todos os serviços requisitados pelo cliente juntamente com suas cotações."
        />
        <Button
          color="primary"
          leftSection={<IconPlus size={18} />}
          onClick={() => {
            confirmActionResult(null, 'adicionar', true);
          }}
        >
          Adicionar
        </Button>
      </Group>
      <Space h="xs" />
      <Table
        showSorterTooltip={false}
        dataSource={data.filter((x) => x.action !== Action.Delete)}
        columns={columns}
        rowKey={(item: ProposalServiceType) => item.id || 0}
        expandable={{
          // rowExpandable: (row) => row.cotacoes.filter((x) => x.action !== Action.Delete).length > 0,
          // eslint-disable-next-line react/no-unstable-nested-components
          expandedRowRender: (row) => (
            <ServiceQuotationEditor
              data={row}
              isEdit
              referenceData={props.referenceData}
              zIndex={props.zIndex + 2}
              onChange={(nextService) => {
                const nextData = [...data];
                const serviceIndex = nextData.findIndex((x) => x.id === row.id);
                if (serviceIndex < 0) {
                  return;
                }

                nextData[serviceIndex] = nextService;
                setProposalGeneralData({ ...proposalGeneralData, servicos: nextData });
                setData(nextData);
              }}
            />
          ),
        }}
        pagination={{
          locale: { items_per_page: 'página' },
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
});

export default ServiceFormView;
